"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyles = exports.theme = void 0;

var _react = _interopRequireDefault(require("react"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _foundations = require("@remote-com/norma/foundations");

var _global = _interopRequireDefault(require("../style/global"));

var _theme = _interopRequireDefault(require("../style/theme"));

var __jsx = _react["default"].createElement;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var theme = _objectSpread(_objectSpread({}, _foundations.theme), _theme["default"]);

exports.theme = theme;

var GlobalStyles = function GlobalStyles() {
  return __jsx(_react["default"].Fragment, null, __jsx(_foundations.GlobalStyles, null), __jsx(_global["default"], null));
};

exports.GlobalStyles = GlobalStyles;